import { Capacitor } from '@capacitor/core';
import type { PlatformKind } from './types';

/**
 * `native` only inside the Capacitor app: the native shell injects its bridge
 * before the page runs, so the answer is fixed for the whole session.
 */
export function detectPlatformKind(): PlatformKind {
  try {
    return Capacitor.isNativePlatform() ? 'native' : 'web';
  } catch {
    // A broken bridge must never take the website down with it.
    return 'web';
  }
}
